import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import i18n from "../../constants/i18n";
import getCorePopUpStore from "../../stores/core/core-popup-store";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const KhattabatAlertDialog = withLiteObserverAndTheme(() => {
  const {
    isAlertVisible,
    alertHeader,
    getAlertTone,
    getAlertActionButton,
    getFinalMessage,
    closePopUps
  } = getCorePopUpStore();
  const { color, Icon } = getAlertTone.get();
  const { labelKey, onClick } = getAlertActionButton.get();

  return (
    <Dialog
      open={isAlertVisible.get()}
      onClose={closePopUps}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ color }}>
          <Icon />
          <Box component="span">{i18n.get(alertHeader.get())}</Box>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ whiteSpace: "pre-wrap" }}>
          {getFinalMessage()}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClick}>
          {i18n.get(labelKey)}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default KhattabatAlertDialog;
